import { Dispatch, FC } from "react";
import { ReportElementInterface } from "../../../middleware/interfaces/report/report-element-interface";
import { ReportElementNoteInterface } from "../../../middleware/interfaces/report/report-element-note-interface";
import { FormatDateFE } from "../../../helper/general/methods";

interface reportElementNotePanelProps {
  reportElement: ReportElementInterface | null;
  setSelectedReportElement: Dispatch<ReportElementInterface | null>;
  setSelectedReportElementNote: Dispatch<ReportElementNoteInterface | null>;
}

const ReportElementNotePanel: FC<reportElementNotePanelProps> = ({
  reportElement,
  setSelectedReportElement,
  setSelectedReportElementNote,
}) => {
  const HandleReportElementNoteDoubleClick = (
    reportElementNote: ReportElementNoteInterface
  ) => {
    setSelectedReportElementNote(reportElementNote);
  };

  return (
    <>
      {(() => {
        if (reportElement) {
          return (
            <div id="reportElementNotePanelWrapper">
              <div className="reportElementNoteHeader">
                <div className="reportElementNoteIdentity">
                  <span className="reportElementNoteHeaderLabel">NOTES</span>
                  <span className="reportElementNoteHeaderName">
                    {reportElement.reportElementName}
                  </span>
                </div>
                <span
                  className="itemDetailsClose"
                  onClick={() => {
                    setSelectedReportElement(null);
                  }}
                >
                  ×
                </span>
              </div>
              <div className="reportElementNoteWrapper">
                {reportElement.reportElementNotes.map((reportElementNote) => (
                  <div
                    key={reportElementNote.reportElementNoteID}
                    className="reportElementNote"
                    onDoubleClick={() =>
                      HandleReportElementNoteDoubleClick(reportElementNote)
                    }
                  >
                    <div className="reportElementNoteMeta">
                      <span>
                        {FormatDateFE(
                          reportElementNote.reportElementNoteDate,
                          true
                        )}
                      </span>
                      <span>·</span>
                      <span className="reportElementNoteAuthor">
                        {reportElementNote.email}
                      </span>
                      {reportElementNote.reportElementNoteEditDate && (
                        <span className="reportElementNoteEdited">EDITED</span>
                      )}
                    </div>
                    <span className="reportElementNoteBody">
                      {reportElementNote.reportElementNote}
                    </span>
                  </div>
                ))}
              </div>
              <span className="reportElementNoteFooter">
                Double-click a note to edit it. Double-click an element header
                to add one.
              </span>
            </div>
          );
        } else {
          // Nothing selected still renders the panel, so the report keeps the
          // same width either way and the cards never reflow under the user.
          return (
            <div id="reportElementNotePanelWrapper">
              <div className="reportElementNoteHeader">
                <div className="reportElementNoteIdentity">
                  <span className="reportElementNoteHeaderLabel">NOTES</span>
                  <span className="reportElementNoteHeaderName">
                    No element selected
                  </span>
                </div>
              </div>
              <span className="reportElementNoteEmpty">
                Select an element to see its notes.
              </span>
              <span className="reportElementNoteFooter">
                Double-click a note to edit it. Double-click an element header
                to add one.
              </span>
            </div>
          );
        }
      })()}
    </>
  );
};

export default ReportElementNotePanel;
